// package: concierge_order
// file: order-concierge.proto

var order_concierge_pb = require("./order-concierge_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var common_pb = require("./common_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var OrderConciergeApiService = (function () {
  function OrderConciergeApiService() {}
  OrderConciergeApiService.serviceName = "concierge_order.OrderConciergeApiService";
  return OrderConciergeApiService;
}());

OrderConciergeApiService.getOrders = {
  methodName: "getOrders",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.OrderPageRequest,
  responseType: order_concierge_pb.OrderResponse
};

OrderConciergeApiService.createOrder = {
  methodName: "createOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.OrderCreateRequest,
  responseType: common_pb.IdResponse
};

OrderConciergeApiService.updateOrder = {
  methodName: "updateOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.OrderUpdateRequest,
  responseType: order_concierge_pb.OrderDetailsResponse
};

OrderConciergeApiService.openOrder = {
  methodName: "openOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_concierge_pb.OrderDetailsResponse
};

OrderConciergeApiService.duplicateOrder = {
  methodName: "duplicateOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.updateOrderArchiveState = {
  methodName: "updateOrderArchiveState",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.OrderArchiveStateRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.deleteOrder = {
  methodName: "deleteOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.launchOrder = {
  methodName: "launchOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.updateOrderFolderRelation = {
  methodName: "updateOrderFolderRelation",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.renameOrder = {
  methodName: "renameOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.OrderRenameRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.getOrderPricing = {
  methodName: "getOrderPricing",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: order_concierge_pb.OrderPricingResponse
};

OrderConciergeApiService.generatePdf = {
  methodName: "generatePdf",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: common_pb.FileResponse
};

OrderConciergeApiService.getOrCreateOnboardingOrder = {
  methodName: "getOrCreateOnboardingOrder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_concierge_pb.OrderDetailsResponse
};

OrderConciergeApiService.getOrderItems = {
  methodName: "getOrderItems",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: common_pb.PageRequest,
  responseType: order_concierge_pb.OrderItemResponse
};

OrderConciergeApiService.createOrderItems = {
  methodName: "createOrderItems",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.OrderItemContainerRequest,
  responseType: order_concierge_pb.OrderItemResponse
};

OrderConciergeApiService.updateOrderItems = {
  methodName: "updateOrderItems",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.OrderItemContainerRequest,
  responseType: order_concierge_pb.OrderItemResponse
};

OrderConciergeApiService.deleteOrderItems = {
  methodName: "deleteOrderItems",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdContainer,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.changeOrderItemStatus = {
  methodName: "changeOrderItemStatus",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.OrderItemChangeStatusRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.getDomainApprovalReview = {
  methodName: "getDomainApprovalReview",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.DomainApprovalReviewRequest,
  responseType: order_concierge_pb.DomainApprovalReviewResponse
};

OrderConciergeApiService.submitDomainApprovalReview = {
  methodName: "submitDomainApprovalReview",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.DomainApprovalReviewSubmitRequest,
  responseType: order_concierge_pb.DomainApprovalReviewSubmitResponse
};

OrderConciergeApiService.getOrderBacklinks = {
  methodName: "getOrderBacklinks",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.OrderBacklinkPageRequest,
  responseType: order_concierge_pb.OrderBacklinkResponse
};

OrderConciergeApiService.exportOrderBacklinksToCsv = {
  methodName: "exportOrderBacklinksToCsv",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.OrderBacklinkExportRequest,
  responseType: common_pb.FileResponseContainer
};

OrderConciergeApiService.raiseOrderItemConcern = {
  methodName: "raiseOrderItemConcern",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.RaiseConcernRequest,
  responseType: order_concierge_pb.ConcernResponse
};

OrderConciergeApiService.getOrderItemConcern = {
  methodName: "getOrderItemConcern",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.GetConcernRequest,
  responseType: order_concierge_pb.ConcernResponse
};

OrderConciergeApiService.addClientConcernMessage = {
  methodName: "addClientConcernMessage",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.AddConcernMessageRequest,
  responseType: order_concierge_pb.ConcernResponse
};

OrderConciergeApiService.createOrderFolder = {
  methodName: "createOrderFolder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.Folder,
  responseType: common_pb.Folder
};

OrderConciergeApiService.updateOrderFolder = {
  methodName: "updateOrderFolder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.Folder,
  responseType: common_pb.Folder
};

OrderConciergeApiService.deleteOrderFolder = {
  methodName: "deleteOrderFolder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.getAllOrderFolders = {
  methodName: "getAllOrderFolders",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: common_pb.PageRequest,
  responseType: common_pb.Folder
};

OrderConciergeApiService.getCampaigns = {
  methodName: "getCampaigns",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.ConciergeCampaignPageRequest,
  responseType: order_concierge_pb.ConciergeCampaignResponse
};

OrderConciergeApiService.getCampaignsForFilter = {
  methodName: "getCampaignsForFilter",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.ConciergeCampaignForFilterRequest,
  responseType: order_concierge_pb.ConciergeCampaignForFilterResponse
};

OrderConciergeApiService.openCampaign = {
  methodName: "openCampaign",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_concierge_pb.ConciergeCampaignDetailResponse
};

OrderConciergeApiService.updateCampaignArchiveState = {
  methodName: "updateCampaignArchiveState",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.CampaignArchiveStateRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.launchCampaignAnalysis = {
  methodName: "launchCampaignAnalysis",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.generateCampaignPrompts = {
  methodName: "generateCampaignPrompts",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignGeneratePromptsRequest,
  responseType: order_concierge_pb.ConciergeCampaignDetailResponse
};

OrderConciergeApiService.getCampaignAnalysisStatus = {
  methodName: "getCampaignAnalysisStatus",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_concierge_pb.ConciergeCampaignAnalysisStatusResponse
};

OrderConciergeApiService.createCampaign = {
  methodName: "createCampaign",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignCreateRequest,
  responseType: order_concierge_pb.ConciergeCampaignDetailResponse
};

OrderConciergeApiService.updateCampaign = {
  methodName: "updateCampaign",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignUpdateRequest,
  responseType: order_concierge_pb.ConciergeCampaignDetailResponse
};

OrderConciergeApiService.updateCampaignContentPlan = {
  methodName: "updateCampaignContentPlan",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignContentPlanUpdate,
  responseType: order_concierge_pb.ConciergeCampaignContentPlanItem
};

OrderConciergeApiService.updateCampaignBudget = {
  methodName: "updateCampaignBudget",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.CampaignUpdateBudgetRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.updateCampaignAnalyticsFrequency = {
  methodName: "updateCampaignAnalyticsFrequency",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.CampaignUpdateAnalyticsFrequencyRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.deleteCampaign = {
  methodName: "deleteCampaign",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.getCampaignAnalytics = {
  methodName: "getCampaignAnalytics",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_concierge_pb.ConciergeCampaignAnalyticsResponse
};

OrderConciergeApiService.getCampaignOverviewAnalytics = {
  methodName: "getCampaignOverviewAnalytics",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignAnalyticsRequest,
  responseType: order_concierge_pb.ConciergeCampaignOverviewAnalyticsResponse
};

OrderConciergeApiService.getCampaignVisibilityAnalytics = {
  methodName: "getCampaignVisibilityAnalytics",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignAnalyticsRequest,
  responseType: order_concierge_pb.ConciergeCampaignVisibilityAnalyticsResponse
};

OrderConciergeApiService.getCampaignCitationAnalytics = {
  methodName: "getCampaignCitationAnalytics",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignAnalyticsRequest,
  responseType: order_concierge_pb.ConciergeCampaignCitationAnalyticsResponse
};

OrderConciergeApiService.getCampaignPromptAnalytics = {
  methodName: "getCampaignPromptAnalytics",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignAnalyticsRequest,
  responseType: order_concierge_pb.ConciergeCampaignPromptAnalyticsResponse
};

OrderConciergeApiService.changeCampaignStatus = {
  methodName: "changeCampaignStatus",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ConciergeCampaignStatusRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.triggerCampaignOrderCreation = {
  methodName: "triggerCampaignOrderCreation",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.exportCampaignAnalysisToCsv = {
  methodName: "exportCampaignAnalysisToCsv",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.CampaignExportRequest,
  responseType: common_pb.FileResponseContainer
};

OrderConciergeApiService.createCampaignFolder = {
  methodName: "createCampaignFolder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.Folder,
  responseType: common_pb.Folder
};

OrderConciergeApiService.updateCampaignFolder = {
  methodName: "updateCampaignFolder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.Folder,
  responseType: common_pb.Folder
};

OrderConciergeApiService.deleteCampaignFolder = {
  methodName: "deleteCampaignFolder",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.getAllCampaignFolders = {
  methodName: "getAllCampaignFolders",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: common_pb.PageRequest,
  responseType: common_pb.Folder
};

OrderConciergeApiService.addDomainsToExcludedList = {
  methodName: "addDomainsToExcludedList",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ExcludedDomainBatchRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.updateExcludedDomain = {
  methodName: "updateExcludedDomain",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ExcludedDomainRequest,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.removeDomainsFromExcludedList = {
  methodName: "removeDomainsFromExcludedList",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdContainer,
  responseType: google_protobuf_empty_pb.Empty
};

OrderConciergeApiService.getExcludedDomains = {
  methodName: "getExcludedDomains",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_concierge_pb.ExcludedDomainsFilterRequest,
  responseType: order_concierge_pb.ExcludedDomainResponse
};

OrderConciergeApiService.listWebhookDeliveries = {
  methodName: "listWebhookDeliveries",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.ListWebhookDeliveriesRequest,
  responseType: order_concierge_pb.ListWebhookDeliveriesResponse
};

OrderConciergeApiService.redeliverWebhook = {
  methodName: "redeliverWebhook",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.RedeliverWebhookRequest,
  responseType: order_concierge_pb.WebhookDeliveryView
};

OrderConciergeApiService.sendTestWebhook = {
  methodName: "sendTestWebhook",
  service: OrderConciergeApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_concierge_pb.SendTestWebhookRequest,
  responseType: order_concierge_pb.SendTestWebhookResponse
};

exports.OrderConciergeApiService = OrderConciergeApiService;

function OrderConciergeApiServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

OrderConciergeApiServiceClient.prototype.getOrders = function getOrders(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getOrders, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.createOrder = function createOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.createOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateOrder = function updateOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.openOrder = function openOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.openOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.duplicateOrder = function duplicateOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.duplicateOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateOrderArchiveState = function updateOrderArchiveState(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateOrderArchiveState, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.deleteOrder = function deleteOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.deleteOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.launchOrder = function launchOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.launchOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateOrderFolderRelation = function updateOrderFolderRelation(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateOrderFolderRelation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.renameOrder = function renameOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.renameOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getOrderPricing = function getOrderPricing(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getOrderPricing, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.generatePdf = function generatePdf(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.generatePdf, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getOrCreateOnboardingOrder = function getOrCreateOnboardingOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getOrCreateOnboardingOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getOrderItems = function getOrderItems(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getOrderItems, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.createOrderItems = function createOrderItems(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.createOrderItems, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateOrderItems = function updateOrderItems(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.updateOrderItems, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.deleteOrderItems = function deleteOrderItems(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.deleteOrderItems, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.changeOrderItemStatus = function changeOrderItemStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.changeOrderItemStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getDomainApprovalReview = function getDomainApprovalReview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getDomainApprovalReview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.submitDomainApprovalReview = function submitDomainApprovalReview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.submitDomainApprovalReview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getOrderBacklinks = function getOrderBacklinks(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getOrderBacklinks, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.exportOrderBacklinksToCsv = function exportOrderBacklinksToCsv(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.exportOrderBacklinksToCsv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.raiseOrderItemConcern = function raiseOrderItemConcern(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.raiseOrderItemConcern, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getOrderItemConcern = function getOrderItemConcern(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getOrderItemConcern, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.addClientConcernMessage = function addClientConcernMessage(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.addClientConcernMessage, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.createOrderFolder = function createOrderFolder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.createOrderFolder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateOrderFolder = function updateOrderFolder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateOrderFolder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.deleteOrderFolder = function deleteOrderFolder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.deleteOrderFolder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getAllOrderFolders = function getAllOrderFolders(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getAllOrderFolders, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaigns = function getCampaigns(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getCampaigns, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaignsForFilter = function getCampaignsForFilter(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getCampaignsForFilter, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.openCampaign = function openCampaign(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.openCampaign, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateCampaignArchiveState = function updateCampaignArchiveState(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateCampaignArchiveState, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.launchCampaignAnalysis = function launchCampaignAnalysis(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.launchCampaignAnalysis, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.generateCampaignPrompts = function generateCampaignPrompts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.generateCampaignPrompts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaignAnalysisStatus = function getCampaignAnalysisStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getCampaignAnalysisStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.createCampaign = function createCampaign(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.createCampaign, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateCampaign = function updateCampaign(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateCampaign, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateCampaignContentPlan = function updateCampaignContentPlan(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateCampaignContentPlan, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateCampaignBudget = function updateCampaignBudget(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateCampaignBudget, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateCampaignAnalyticsFrequency = function updateCampaignAnalyticsFrequency(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateCampaignAnalyticsFrequency, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.deleteCampaign = function deleteCampaign(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.deleteCampaign, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaignAnalytics = function getCampaignAnalytics(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getCampaignAnalytics, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaignOverviewAnalytics = function getCampaignOverviewAnalytics(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getCampaignOverviewAnalytics, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaignVisibilityAnalytics = function getCampaignVisibilityAnalytics(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getCampaignVisibilityAnalytics, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaignCitationAnalytics = function getCampaignCitationAnalytics(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getCampaignCitationAnalytics, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getCampaignPromptAnalytics = function getCampaignPromptAnalytics(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.getCampaignPromptAnalytics, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.changeCampaignStatus = function changeCampaignStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.changeCampaignStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.triggerCampaignOrderCreation = function triggerCampaignOrderCreation(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.triggerCampaignOrderCreation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.exportCampaignAnalysisToCsv = function exportCampaignAnalysisToCsv(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.exportCampaignAnalysisToCsv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.createCampaignFolder = function createCampaignFolder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.createCampaignFolder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateCampaignFolder = function updateCampaignFolder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateCampaignFolder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.deleteCampaignFolder = function deleteCampaignFolder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.deleteCampaignFolder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getAllCampaignFolders = function getAllCampaignFolders(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getAllCampaignFolders, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.addDomainsToExcludedList = function addDomainsToExcludedList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.addDomainsToExcludedList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.updateExcludedDomain = function updateExcludedDomain(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.updateExcludedDomain, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.removeDomainsFromExcludedList = function removeDomainsFromExcludedList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.removeDomainsFromExcludedList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.getExcludedDomains = function getExcludedDomains(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(OrderConciergeApiService.getExcludedDomains, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.listWebhookDeliveries = function listWebhookDeliveries(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.listWebhookDeliveries, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.redeliverWebhook = function redeliverWebhook(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.redeliverWebhook, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

OrderConciergeApiServiceClient.prototype.sendTestWebhook = function sendTestWebhook(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(OrderConciergeApiService.sendTestWebhook, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.OrderConciergeApiServiceClient = OrderConciergeApiServiceClient;

